var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCurlyShapes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 374,
    viewBox: "0 0 480 374",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    clipPath: "url(#clip0_4_69)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -50.5,
    cy: -157.498,
    r: 528,
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.406 -157.499C394.406 88.2117 194.992 287.404 -51.0039 287.404C-297 287.404 -496.414 88.2117 -496.414 -157.499C-496.414 -403.21 -297 -602.403 -51.0039 -602.403C194.992 -602.403 394.406 -403.21 394.406 -157.499Z",
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.451 -157.497C322.451 49.0427 155.244 216.471 -51.0099 216.471C-257.263 216.471 -424.471 49.0427 -424.471 -157.497C-424.471 -364.037 -257.263 -531.464 -51.0099 -531.464C155.244 -531.464 322.451 -364.037 322.451 -157.497Z",
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -50.5001,
    cy: -156.486,
    r: 317.219,
    stroke: "white",
    strokeWidth: 5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_69"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1061,
    height: 1061,
    fill: "white",
    transform: "translate(-581 -687.998)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurlyShapes);
export default __webpack_public_path__ + "static/media/curly-shapes.58c2f4d739086b6079b16d97522a2210.svg";
export { ForwardRef as ReactComponent };